export default __webpack_public_path__ + "static/media/boost-facebook-user-engagement.32772092.svg";